import * as types from './constants';

// Get Promotions
export const getShopifyTokensRequest = data => (
  { type: types.GET_SHOPIFY_TOKENS_REQUEST, payload: data }
);

export const getShopifyTokensDone = data => (
  { type: types.GET_SHOPIFY_TOKENS_DONE, payload: data }
);

export const getShopifyTokensFailed = errors => (
  { type: types.GET_SHOPIFY_TOKENS_FAILED, payload: errors }
);

// Operations
export const shopifyTokensSetPage = data => (
  { type: types.SHOPIFY_TOKENS_SET_PAGE, payload: data }
);